import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useStyles from '../../../useStyles';
import BottomEdgeDivider from './BottomEdgeDivider';

const useLayoutStyles = makeStyles((theme) => ({
    topSpreadRow: {
        justifyContent: 'space-between',
        width: '100%',
        boxSizing: 'border-box',
        gap: theme.spacing(1),
    },
    titleLead: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    titleLeadHeading: {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    trailingSlot: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
    },
    leadingSlot: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
    },
}));

const AppPageTitle = ({
    title,
    icon,
    align = 'center',
    dividerInsetX = 16,
    dividerColor = '#000000',
    dividerThickness = 1,
    hideDivider = false,
    disableDefaultStyles = false,
    className,
    topClassName,
    titleClassName,
    iconWrapClassName,
    dividerWrapClassName,
    leadingAction,
    trailingAction,
}) => {
    const classes = useStyles();
    const layoutClasses = useLayoutStyles();
    const useSpreadTopRow = Boolean(icon) || Boolean(leadingAction) || Boolean(trailingAction);
    const rootClassName = [disableDefaultStyles ? '' : classes.appPageTitleRoot, className || ''].filter(Boolean).join(' ');
    const resolvedTopClassName = [
        disableDefaultStyles ? '' : classes.appPageTitleTop,
        !disableDefaultStyles && align === 'start' ? classes.appPageTitleTopStart : '',
        topClassName || '',
        useSpreadTopRow ? layoutClasses.topSpreadRow : '',
    ].filter(Boolean).join(' ');
    const resolvedTitleClassName = [
        disableDefaultStyles ? '' : classes.appPageTitleText,
        !disableDefaultStyles && align === 'start' ? classes.appPageTitleTextStart : '',
        titleClassName || '',
        useSpreadTopRow ? layoutClasses.titleLeadHeading : '',
    ].filter(Boolean).join(' ');
    const resolvedIconWrapClassName = [disableDefaultStyles ? '' : classes.appPageTitleIconWrap, iconWrapClassName || ''].filter(Boolean).join(' ');
    const resolvedDividerWrapClassName = [disableDefaultStyles ? '' : classes.appPageTitleDividerWrap, dividerWrapClassName || ''].filter(Boolean).join(' ');

    return (
        <Box className={rootClassName}>
            <Box className={resolvedTopClassName}>
                {useSpreadTopRow ? (
                    <>
                        <Box className={layoutClasses.titleLead}>
                            {leadingAction ? <Box className={layoutClasses.leadingSlot}>{leadingAction}</Box> : null}
                            <h2 className={resolvedTitleClassName}>{title}</h2>
                            {icon ? <Box className={resolvedIconWrapClassName}>{icon}</Box> : null}
                        </Box>
                        {trailingAction ? <Box className={layoutClasses.trailingSlot}>{trailingAction}</Box> : null}
                    </>
                ) : (
                    <h2 className={resolvedTitleClassName}>{title}</h2>
                )}
            </Box>
            {!hideDivider ? (
                <Box className={resolvedDividerWrapClassName}>
                    <BottomEdgeDivider insetX={dividerInsetX} thickness={dividerThickness} color={dividerColor} />
                </Box>
            ) : null}
        </Box>
    );
};

AppPageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    align: PropTypes.oneOf(['center', 'start']),
    dividerInsetX: PropTypes.number,
    dividerColor: PropTypes.string,
    dividerThickness: PropTypes.number,
    hideDivider: PropTypes.bool,
    disableDefaultStyles: PropTypes.bool,
    className: PropTypes.string,
    topClassName: PropTypes.string,
    titleClassName: PropTypes.string,
    iconWrapClassName: PropTypes.string,
    dividerWrapClassName: PropTypes.string,
    leadingAction: PropTypes.node,
    trailingAction: PropTypes.node,
};

export default AppPageTitle;
